import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.iterator.js";
// @ts-ignore
import { encode } from "google-polyline";
export function parsePoints(polygonFromMap) {
  if (!polygonFromMap) return;
  var numbers = polygonFromMap.match(/[-]?[\d]*[.]?[\d]+/g);
  if (!numbers) return;
  var latLngs = [];
  for (var i = 0; i < numbers.length; i++) {
    latLngs.push({
      lat: parseFloat(numbers[i + 1]),
      lng: parseFloat(numbers[i])
    });
    i++;
  }
  return latLngs;
}
/**
 * @param polygon An array of latitude and polygon that will be used to design an area in a map
 * @param forUrl If true, the output string will be encoded as a URI so respecting the UTF-8 encoding
 * */
export function encodePolygon(polygon) {
  var forUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var polygonArr = [];
  polygon.forEach(p => {
    polygonArr.push([p.lat, p.lng]);
  });
  var encodedPolygon = encode(polygonArr);
  return forUrl ? encodeURIComponent(encodedPolygon) : encodedPolygon;
}
export function getMinMaxLatLng(polygon) {
  var minmax = {
    miny: polygon[0].lat,
    maxy: polygon[0].lat,
    minx: polygon[0].lng,
    maxx: polygon[0].lng
  };
  polygon.forEach(p => {
    minmax.miny = Math.min(minmax.miny, p.lat);
    minmax.maxy = Math.max(minmax.maxy, p.lat);
    minmax.minx = Math.min(minmax.minx, p.lng);
    minmax.maxx = Math.max(minmax.maxx, p.lng);
  });
  return minmax;
}
export function removeDuplicatePoints(latLngs) {
  if (latLngs.length <= 0) return [];
  var uniqueCoordinates = new Set();
  var unique = latLngs.filter(x => {
    var isDuplicate = uniqueCoordinates.has(x.lat + x.lng);
    var coordinate = x.lat + x.lng;
    uniqueCoordinates.add(coordinate);
    return !isDuplicate;
  });
  return unique;
}
export function calcPolygonCenter(points) {
  var lat = 0;
  var lng = 0;
  for (var i = 0; i < points.length; i++) {
    var point = points[i];
    lat += point.lat;
    lng += point.lng;
  }
  return {
    lat: lat / points.length,
    lng: lng / points.length
  };
}
export function validateMap(map) {
  var _a;
  var mapRange = window._mapRange || 10000;
  if (map) {
    var center = (_a = map.getShape()) === null || _a === void 0 ? void 0 : _a.getCenter();
    var points = map.getShapePoints();
    if (points) {
      for (var i = 0; i < points.length; i++) {
        if (map.getDistance(points[i], center) > mapRange) return false;
      }
    }
    return true;
  }
  return false;
}
export function getPolygonString(shapePoints) {
  var polygonString = "POLYGON((";
  shapePoints.forEach(point => {
    polygonString += "".concat(point.lng, " ").concat(point.lat, ", ");
  });
  polygonString += "".concat(shapePoints[0].lng, " ").concat(shapePoints[0].lat, "))");
  return polygonString;
}